var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V6M17 3V6",
    stroke: "#96989B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21.47 12 21.7065 12.0005 21.8535 12.1465C21.9995 12.2935 22 12.529 22 13V18C22 19.886 22.0001 20.8281 21.4141 21.4141C20.8281 22.0001 19.886 22 18 22H6C4.114 22 3.17194 22.0001 2.58594 21.4141C1.99994 20.8281 2 19.886 2 18V13C2 12.53 2.00049 12.2935 2.14648 12.1465C2.29348 12.0005 2.529 12 3 12H21ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H8ZM18 5C19.886 5 20.8281 4.99994 21.4141 5.58594C22.0001 6.17194 22 7.114 22 9C22 9.471 21.9995 9.70652 21.8535 9.85352C21.7065 9.99951 21.47 10 21 10H3C2.529 10 2.29348 9.99951 2.14648 9.85352C2.00049 9.70652 2 9.47 2 9C2 7.114 1.99994 6.17194 2.58594 5.58594C3.17194 4.99994 4.114 5 6 5H18Z",
    fill: "#96989B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCalendar);
export default __webpack_public_path__ + "static/media/purchase-calendar.ed3ec1392fa6872e4e97531d1b39f088.svg";
export { ForwardRef as ReactComponent };